
import React from 'react';
import SecureAdminManagementPanel from '../components/SecureAdminManagementPanel';
import BottomTabNavigation from '../components/navigation/BottomTabNavigation';

const SecureAdminManagementPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1">
        <SecureAdminManagementPanel />
      </div>
      <BottomTabNavigation />
    </div>
  );
};

export default SecureAdminManagementPage;
